import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { SagaActions } from "../../../redux/actionTypes";
import { Col, Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";

import { getSignUpOtpReq } from "../../../api/auth/otpRequests";
import { verifyOtpReq } from "../../../api/auth/otpRequests";
import Timer from "../../../components/timer/timer";
import appLogo from "../../../assets/images/logo150.png";

import prodLogo from "../../../assets/images/logo_prod_1.png";
import devLogo from "../../../assets/images/logo_dev.png";
import stageLogo from "../../../assets/images/logo_stage.png";

const SmsOtpBlock = (props) => {
  const { onSubmit, onResendOtp, otherData } = props;
  const Dispatch = useDispatch();

  const [otp, setOtp] = useState("");
  const [timerRunning, settimerRunning] = useState(true);
  const [resetTimer, setresetTimer] = useState(false);
  const [btnLoading, setbtnLoading] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  const verifyOtp = async (data) => {
    try {
      if (!otp || otp.length < 6) return seterrorMsg("Invalid OTP");
      setbtnLoading(true);
      const body = {
        userID: localStorage.getItem("@userId"),
        otp: otp,
        typeIs: "SMS",
      };
      const res = await verifyOtpReq(body);
      setbtnLoading(false);
      toast.success(res?.message);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "smsOtpBlock",
          methodName: "verifyOtp",
          type: "info",
        },
      });
      onSubmit();
    } catch (error) {
      setbtnLoading(false);
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "smsOtpBlock",
          methodName: "verifyOtp",
          type: "error",
        },
      });
    }
    seterrorMsg("");
  };

  const _onPress = ({ key, data }) => {
    const fun = {
      null: (data) => {},
      submit: (data) => verifyOtp({ otp }),
      resend: () => {
        setresetTimer(!resetTimer);
        onResendOtp();
      },
    };
    fun[key](data);
  };
  return (
    <div className={`inputsContainer h-100 py-2  border-info`}>
      <Col lg={3} xs={4} sm={2} className="m-2 mb-3">
        <div className="logo_block">
          {process.env.REACT_APP__ENV_IS === "prod" && <img src={prodLogo} />}
          {process.env.REACT_APP__ENV_IS === "dev" && <img src={devLogo} />}
          {process.env.REACT_APP__ENV_IS === "stage" && <img src={stageLogo} />}
        </div>
      </Col>
      <div className="inputs_block w-100 py-1 px-lg-4 py-4 px-xs-2 border-info">
        <div className={`mb-5 flex-1 d-flex flex-column`}>
          <h4 className={`x-lg-text`}>Verify Phone OTP</h4>
          <p className={`md-text`}>
            Received via SMS on {localStorage.getItem("@ph")}
          </p>
          <p>&nbsp;</p>
          <p></p>
          <div>
            <div className="mb-5">
              {/* <label>OTP</label> */}
              <div>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>&nbsp;</span>}
                  renderInput={(props, index) => (
                    <input
                      type="number"
                      id={index}
                      className="border"
                      {...props}
                    />
                  )}
                  inputStyle={
                    "border border-secondary-subtle rounded me-2 h-100 py-2 w-100"
                  }
                  placeholder="000000"
                />
              </div>
              <div className={`d-flex`}>
                <p className={`x-sm-text text-danger mt-1`}>
                  {errorMsg ? errorMsg : ``}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={`d-flex align-items-center justify-content-between`}>
          <button
            type="button"
            className={"border border-0 border-white bg-white ms-0 me-2"}
            onClick={() => _onPress({ key: "resend" })}
          >
            <p className={`primary-color x-sm-text`}>Resend OTP</p>
          </button>
          <Timer
            runTimer={timerRunning}
            reset={resetTimer}
            onFinish={() => settimerRunning(false)}
            onStart={() => console.log("started")}
            customeTimer={(min, sec) => (
              <p className={`primary-color x-sm-text`}>
                {`0${min}:${sec < 10 ? "0" + sec : sec}`}
              </p>
            )}
          />
        </div>
        <p>&nbsp;</p>
        {/* <p></p>
        <div className="flex-grow-1  d-flex flex-1"></div> */}

        <div className={``}>
          <button
            className={`sbmit_btn md-text`}
            type={`button`}
            onClick={() => _onPress({ key: "submit" })}
          >
            Login
            <div className={`ms-2`}>
              {btnLoading && (
                <Spinner animation="border" variant="primary" size="sm" />
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsOtpBlock;
